export const capitalize = (string: string | null | undefined): string | null => {
  if (!string || typeof string !== 'string') {
    return null
  }
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const snakeToCamel = (string: string): string => {
  return string.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
}

// For the few components that feed a string into a dangerouslySetInnerHTML sink.
export const escapeHtml = (value: string | null | undefined): string =>
  (value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
